import { render } from "./SottoProgettoForm.vue?vue&type=template&id=09100fff&ts=true"
import script from "./SottoProgettoForm.vue?vue&type=script&lang=ts"
export * from "./SottoProgettoForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__